const common = {
  Loading: "Загрузка",
  signUp: "Зарегистрироваться",
  login: "Войти",
  logout: "Выйти",
  email: "Электронная почта",
  emailFormatErrorTips: "Неправильный формат электронной почты",
  emailDifferentTips: "Пожалуйста, введите один и тот же адрес электронной почты в оба поля.",
  emailRegisteredTips: "Эта электронная почта была зарегистрирована, пожалуйста, выберите другую",
  password: "Пароль",
  passwordFormatErrorTips:
    "Пароль должен состоять из 8–50 символов и содержать как минимум две категории из следующих: цифра, буква или специальный символ.",
  passwordDifferentTips: "Пожалуйста, введите один и тот же пароль в оба поля.",
  verificationCode: "Код подтверждения",
  verificationCodeErrorTips: "Неверный проверочный код, введите правильный еще раз",
  confirm: "Подтвердить",
  cancel: "Отменить",
  submit: "Отправить",
  confirmEmail: "Подтвердить электронную почту",
  formEmptyErrorTips: "Здесь не может быть пусто.",
  country: "Страна/Регион",
  birthday: "День рождения",
  anonymous: "Аноним",
  name: "Имя",
  nameFormatErrorTips: "Имя пользователя должно состоять из 50 символов и не содержать специальных символов.",
  okBtn: "OK",
  serverErrorTips: "Извините, появилась ошибка, пожалуйста, попробуйте еще раз позже.",
  updateSuccessTips: "Изменено успешно",
  authorizationExpiredErrorTips: "Срок действия авторизации истек, пожалуйста, войдите снова.",
  requestFrequentlyErrorTips: "За короткий период времени было сделано слишком много одинаковых запросов, пожалуйста, повторите попытку позже.",
};

export default common;
